import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import InboundFlowReferencesSection from 'automation-ui-management/components/workflow-references/InboundFlowReferencesSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WorkflowReferenceModal = ({
  onDismissModal,
  inboundReferences
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onDismissModal
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-management.modal.workflowReferenceModal.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-management.modal.workflowReferenceModal.unableToDeleteWorkflowExplanation"
        })
      }), /*#__PURE__*/_jsx(InboundFlowReferencesSection, {
        inboundReferences: inboundReferences
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        type: "submit",
        onClick: onDismissModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-management.modal.workflowReferenceModal.okButton"
        })
      })
    })]
  });
};
export default WorkflowReferenceModal;